import { Controller } from "@hotwired/stimulus"

export default class CountdownController extends Controller {
  static targets = ["output"]

  static values = {
    startTime: String,
    endTime: String,
    url: String
  }

  connect() {
    this.startTime = new Date(this.startTimeValue)
    this.endTime = new Date(this.endTimeValue)
    this.apiCalled = false

    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  async callApi() {
    if (!this.hasUrlValue || this.apiCalled) return

    this.apiCalled = true

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        },
        credentials: 'same-origin'
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error(error)
    }
  }

  tick() {
    const now = new Date()
    if (now < this.startTime) {
      this.outputTarget.textContent = 'Countdown not started'
      return
    }
    if (now >= this.endTime) {
      clearInterval(this.interval)
      this.outputTarget.textContent = this.outputTarget.dataset.text || 'Countdown ended'
      this.callApi()
      return
    }

    const diff = this.endTime - now
    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
    const minutes = Math.floor((diff / (1000 * 60)) % 60)
    const seconds = Math.floor((diff / 1000) % 60)

    const parts = []

    if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`)
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`)
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`)
    parts.push(`${seconds} second${seconds !== 1 ? 's' : ''}`)

    this.outputTarget.textContent = parts.join(' ')
  }
}
